module.exports = __webpack_public_path__ + "img/award-content-zh.2486dee7.png";